const EventEmitter = require('events');

class NotificationService extends EventEmitter {
	constructor () {
		super();
		this.eventEmitter = new EventEmitter();

		this.stepAddNotification = 150;
		this.countAddNotification = -this.stepAddNotification;
		this.constListener = {
			add: 'addNotification',
		};
		this.constType = {
			error:   'error',
			warning: 'warning',
			info:    'info',
			success: 'success',
		};
	}

	addListener (eventName, listener) {
		this.eventEmitter.addListener(eventName, listener);
	}

	on (eventName, listener) {
		this.eventEmitter.on(eventName, listener);
	}

	removeEventListener (eventName, listener) {
		this.eventEmitter.removeListener(eventName, listener);
	}

	errors (payload) {
		if (!(payload instanceof Object)) {
			console.log('params need instanceof object');

			return false;
		}

		if (!payload?.errors) return false;

		for (const key in payload.errors) {
			this.error({
				title:   'error_validation',
				message: payload.errors[key][0],
				time:    payload?.time,
				remove:  payload?.remove,
			});
		}
	}

	error (payload) {
		if (!(payload instanceof Object)) {
			console.log('params need instanceof object');

			return false;
		}
		if (payload.title === undefined || payload.message === undefined) {
			console.log('title and message required');

			return false;
		}

		this.emit(this.constListener.add, {
			type:    this.constType.error,
			title:   payload.title,
			message: payload.message,
			time:    payload.time,
			remove:  payload.remove,
			view:    payload.view,
			viewClick: payload.viewClick,
		});
	}

	success (payload) {
		if (!(payload instanceof Object)) {
			console.log('params need instanceof object');

			return false;
		}
		if (payload.title === undefined || payload.message === undefined) {
			console.log('title and message required');

			return false;
		}

		this.emit(this.constListener.add, {
			type:    this.constType.success,
			title:   payload.title,
			message: payload.message,
			time:    payload.time,
			remove:  payload.remove,
			view:    payload.view,
			viewClick: payload.viewClick,
		});
	}

	info (payload) {
		if (!(payload instanceof Object)) {
			console.log('params need instanceof object');

			return false;
		}
		if (payload.title === undefined || payload.message === undefined) {
			console.log('title and message required');

			return false;
		}

		this.emit(this.constListener.add, {
			type:    this.constType.info,
			title:   payload.title,
			message: payload.message,
			time:    payload.time,
			remove:  payload.remove,
			view:    payload.view,
			viewClick: payload.viewClick,
		});
	}

	message (payload) {
		if (!(payload instanceof Object)) {
			console.log('params need instanceof object');

			return false;
		}
		if (payload.type === undefined || payload.message === undefined) {
			console.log('type and message required');

			return false;
		}

		this.emit(this.constListener.add, {
			title:   payload.title,
			type:    payload.type,
			message: payload.message,
			time:    payload.time,
			remove:  payload.remove,
			view:    payload.view,
			viewClick: payload.viewClick,
		});
	}

	emit (event, payload, error = false) {
		this.countAddNotification += this.stepAddNotification;

		setTimeout(() => {
			this.eventEmitter.emit(event, payload, error);

			if (this.countAddNotification - this.stepAddNotification > 0) {
				this.countAddNotification -= this.stepAddNotification;
			}
		}, this.countAddNotification);
	}

	getEventEmitter () {
		return this.eventEmitter;
	}
}

export default new NotificationService();
